import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import {useEffect, useMemo, useState, useRef} from 'react'
import {
  fetchData,
  fetchFormData,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import Select from 'react-select'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'

import 'react-datepicker/dist/react-datepicker.css'
import {Link} from 'react-router-dom'

import {ToastContainer} from 'react-toastify'
import Swal from 'sweetalert2'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit, faMinus, faPlus} from '@fortawesome/free-solid-svg-icons'
import {faSpinner} from '@fortawesome/free-solid-svg-icons'
import {Tr} from '../../../_metronic/i18n/Tr'


const Popup = (props: any) => {
    // add / edit facility states
  let t = Tr()

    const [error, setError] = useState(Object)
    const [disable, setDisable] = useState(false)
    const [categoryList, setCategorylist] = useState([])
    const [imageUrls, setImageUrls] = useState<string[]>([])
    const [isLoaded, setIsLoaded] = useState(false)

    const [accommodation, setAccommodation] = useState(
      props.passdata.data || [{en_name: '', ru_name: '', uz_name: '', categoryId: '', image: ''}]
    )

    const addaccommodation = async () => {
      var tmp: any = [
        ...accommodation,
        {en_name: '', ru_name: '', uz_name: '', categoryId: '', image: ''},
      ]
      setAccommodation(tmp)
    }

    const handleacccommodationchange = (index: number, field: string, value: string) => {
      var accomodationslots: any = [...accommodation]
      accomodationslots[index][field] = value
      setAccommodation(accomodationslots)
    }

    useEffect(() => {
      if (categoryList.length != 0) {
        let tmpData = props.passdata.data.map((val: any) => {
          return {
            ...val,
            categoryId: categoryList.find((item: any) => item.value == val.categoryId),
          }
        })
        setAccommodation(tmpData || [{en_name: '', ru_name: '', uz_name: '', categoryId: ''}])
      }
    }, [categoryList])

    const getCategoryList = async () => {
      var response: any = await fetchData('admin/categorylist', Object)
      if (response.status == '200') {
        var data = response.data.map((item: any) => {
          return {value: item.categoryId, label: item.en_name}
        })

        var filterr = data.filter((item: any) => item.value == 1 || item.value == 2)

        setCategorylist(filterr)
      } else {
        toasterrormsg(response.message)
      }
    }
    const handleCategoryChange = (index: any, field: string, selectedOption: any) => {
      var accomodationslots: any = [...accommodation]
      accomodationslots[index][field] = selectedOption
      setAccommodation(accomodationslots)
    }
    const handleImageChange = (index: number, selectedImage: File) => {
      var accomodationslots: any = [...accommodation]
      accomodationslots[index]['image'] = selectedImage
      setAccommodation(accomodationslots)

      const updatedImageUrls = [...imageUrls]
      updatedImageUrls[index] = URL.createObjectURL(selectedImage)
      setImageUrls(updatedImageUrls)
    }
    const handleImageLoad = () => {
      setIsLoaded(true)
    }

    useEffect(() => {
      getCategoryList()
    }, [])
    const removeAccommodation = (id: number, index: number) => {
      if (id == null || id == undefined) {
        if (accommodation.length === 1) {
          Swal.fire({
            icon: 'error',
            title: t('Cannot Remove All Rows'),
            text: t('At least one row must be present'),
          })
        } else {
          const updatedAccommodation = [...accommodation]

          // Remove the element at the specified index
          updatedAccommodation.splice(index, 1)

          // Update the state with the new array
          setAccommodation(updatedAccommodation)
        }
      } else {
        if (accommodation.length === 1) {
          Swal.fire({
            icon: 'error',
            title: t('Cannot Remove All Rows'),
            text: t('At least one row must be present'),
          })
        } else {
          var tmp2 = sessionStorage.getItem('admin')
          // Step 2: Check if the item is not null
          if (tmp2) {
            // Step 3: Parse the JSON string
            var adminData = JSON.parse(tmp2)
            // Step 4: Access the adminId
            var adminId = adminData.adminId
          }
          Swal.fire({
            title: t('Are you sure?'),
            text: t('You Want To Delete this row!'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Ok'),
            cancelButtonText: t('Cancel'),
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                var param: any = {
                  adminId: adminId,
                  id: id,
                }
                const response = await fetchData('admin/delete' + props.passdata.apiName, param)

                if (response.status == '200') {
                  const updatedAccommodation = [...accommodation]
                  updatedAccommodation.splice(index, 1)
                  setAccommodation(updatedAccommodation)
                  toastsuccessmsg('Deleted Successfully')
                } else {
                  toasterrormsg(response.message)
                }
              } catch (error) {
                toasterrormsg('An error occurred while processing your request.')
              }
            }
          })
        }
      }
    }

    const saveaccommodation = async () => {
      setDisable(true)
      var tmp2 = sessionStorage.getItem('admin')
      // Step 2: Check if the item is not null
      if (tmp2) {
        // Step 3: Parse the JSON string
        var adminData = JSON.parse(tmp2)
        // Step 4: Access the adminId
        var adminId = adminData.adminId
      }
      for (const item of accommodation) {
        let param: any
        if (props.passdata.apiName == 'propertytype') {
          param = {
            enName: item.en_name.trim(),
            ruName: item.ru_name.trim(),
            uzName: item.uz_name.trim(),
            id: item.id,
            categoryId: item.categoryId.value,
            adminId: adminId,
          }
        } else if (props.passdata.apiName == 'amenity' || props.passdata.apiName == 'subcategory') {
          param = new FormData()
          param.append('enName', item.en_name.trim())
          param.append('ruName', item.ru_name.trim())
          param.append('uzName', item.uz_name.trim())
          param.append('id', item.id)
          param.append(
            'categoryId',
            props.passdata.apiName == 'subcategory' ? item.categoryId.value : '1'
          )
          param.append('adminId', adminId)

          if (item.image != null && item.image != undefined) {
            param.append('image', item.image ? item.image : '')
          }
        } else {
          param = {
            enName: item.en_name.trim(),
            ruName: item.ru_name.trim(),
            uzName: item.uz_name.trim(),
            id: item.id,
            categoryId: '1',
            adminId: adminId,
          }
        }

        if (props.passdata.apiName == 'amenity' || props.passdata.apiName == 'subcategory') {
          var res = await fetchFormData('admin/addEdit' + props.passdata.apiName, param)
        } else {
          var res = await fetchData('admin/addEdit' + props.passdata.apiName, param)
        }
      }

      if (res.status == '200') {
        toastsuccessmsg('Updated Successfully')

        setDisable(false)
        props.onHide()
      } else {
        setDisable(false)
        toasterrormsg(res.message)
      }
    }

    const validate = () => {
      var errotmp: any = {}
      var err = 0

      accommodation.forEach((accomslot: any, index: any) => {
        if (
          accomslot.en_name.trim() == '' ||
          accomslot.en_name.trim() == null ||
          accomslot.en_name.trim() == undefined
        ) {
          errotmp[`en_name${index}`] = t('Property Category English Name Is Required')
          err = 1
        } else if (accomslot.en_name.trim().length > 50) {
          errotmp[`en_name${index}`] = t('Property Category English Name Is Too Large')
          err = 1
        } else if (
          accomslot.ru_name.trim() == '' ||
          accomslot.ru_name.trim() == null ||
          accomslot.ru_name.trim() == undefined
        ) {
          errotmp[`ru_name${index}`] = t('Property Category Russian Name Is Required')
          err = 1
        } else if (accomslot.ru_name.trim().length > 50) {
          errotmp[`ru_name${index}`] = t('Property Category Russian Name Is Too Large')
          err = 1
        } else if (
          accomslot.uz_name.trim() == '' ||
          accomslot.uz_name.trim() == null ||
          accomslot.uz_name.trim() == undefined
        ) {
          errotmp[`uz_name${index}`] = t('Property Category Uzbek Name Is Required')
          err = 1
        }

        if (props.passdata.apiName == 'subcategory' || props.passdata.apiName == 'propertytype') {
          if (
            accomslot.categoryId == '' ||
            accomslot.categoryId == undefined ||
            accomslot.categoryId == null
          ) {
            errotmp[`categoryId${index}`] = t('Category Is Required')
            err = 1
          }
        }
      })

      setError(errotmp)
      if (err == 0) {
        saveaccommodation()
      }
    }

    // add / edit facility state end
    return (
      <Modal
        {...props}
        size='xl'
        aria-labelledby='contained-modal-title-hcenter'
        dialogClassName='maxwidth1000px'
        centered
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className='d-flex align-items-center col-10'>
            <h4 className='fw-bold'>
              {props.passdata !== '' ? t('Edit') : t('Add')} {t('Filters')}
            </h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            className='stepper stepper-links d-flex flex-column'
            id='kt_create_account_stepper'
            data-kt-stepper='true'
          >
            <div className='mx-auto w-100 py-10 row' id='kt_create_account_form'>
              <label className='h3 mb-5'>{t('Add Filter Values')}</label>
              {accommodation.map((item: any, index: any) => {
                return (
                  <>
                    <div className='row'>
                      {(props.passdata.apiName == 'amenity' ||
                        props.passdata.apiName == 'subcategory') && (
                        <div className='col-lg-2'>
                          <div
                            className='image-input image-input-outline'
                            data-kt-image-input='true'
                          >
                            {!isLoaded && (
                              <div
                                className='image-loader'
                                style={{
                                  position: 'absolute',
                                  top: '0',
                                  left: '0',
                                  width: '100%',
                                  height: '100%',
                                  backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent background
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <FontAwesomeIcon icon={faSpinner} spin />
                              </div>
                            )}
                            <img
                              onLoad={handleImageLoad}
                              alt='images'
                              className='image-input-wrapper w-70px h-70px changeimg pointer'
                              src={
                                imageUrls[index]
                                  ? imageUrls[index]
                                  : item.image != ''
                                  ? item.image
                                  : toAbsoluteUrl('/media/default.jpg')
                              }
                            />
                            <label className='text-danger'>{error[`image${index}`] || ''}</label>

                            <label
                              className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                              data-kt-image-input-action='change'
                              data-bs-toggle='tooltip'
                              title='Change avatar'
                            >
                              <i className='fa fa-edit'></i>
                              <input
                                type='file'
                                name='image'
                                accept='.png, .jpg, .jpeg'
                                style={{display: 'none'}}
                                onChange={(e: any) => {
                                  if (
                                    e.target.files[0]?.type !== 'image/jpeg' &&
                                    e.target.files[0]?.type !== 'image/jpg' &&
                                    e.target.files[0]?.type !== 'image/png'
                                  ) {
                                    alert('Upload Only JPG, PNG Or PNG File')
                                  } else if (e.target.files[0]) {
                                    handleImageChange(index, e.target.files[0])
                                  }
                                }}
                              />
                              <input type='hidden' name='avatar_remove' />
                            </label>
                          </div>
                        </div>
                      )}

                      <div className='col-lg-2'>
                        <label className='required fw-bold fs-6'>{t('English Value')}</label>
                        <input
                          type='text'
                          name='enName2'
                          className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                          placeholder={t('English Value')}
                          value={item.en_name}
                          onChange={(event: any) =>
                            handleacccommodationchange(index, 'en_name', event.target.value)
                          }
                        />
                        <label className='text-danger'>{error[`en_name${index}`] || ''}</label>
                      </div>
                      <div className='col-lg-2'>
                        <label className='required fw-bold fs-6'>{t('Russian Value')}</label>
                        <input
                          type='text'
                          name='accommodationname'
                          className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                          placeholder={t('Russian Value')}
                          value={item.ru_name}
                          onChange={(event: any) =>
                            handleacccommodationchange(index, 'ru_name', event.target.value)
                          }
                        />
                        <label className='text-danger'>{error[`ru_name${index}`] || ''}</label>
                      </div>
                      <div className='col-lg-2'>
                        <label className='required fw-bold fs-6'>{t('Uzbek Value')}</label>
                        <input
                          type='text'
                          name='accommodationname'
                          className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                          placeholder={t('Uzbek Value')}
                          value={item.uz_name}
                          onChange={(event: any) =>
                            handleacccommodationchange(index, 'uz_name', event.target.value)
                          }
                        />
                        <label className='text-danger'>{error[`uz_name${index}`] || ''}</label>
                      </div>
                      {props.passdata.apiName == 'propertytype' ||
                      props.passdata.apiName == 'subcategory' ? (
                        <div className='col-lg-3'>
                          <label className='required fw-bold fs-6'>
                            {t('Select Category Value')}
                          </label>
                          <Select
                            name='category'
                            id='category'
                            placeholder={t('Select Category')}
                            isSearchable={true}
                            options={categoryList}
                            value={item.categoryId}
                            onChange={(selectedOption) => {
                              handleCategoryChange(index, 'categoryId', selectedOption)
                            }}
                          />
                          <label className='text-danger'>{error[`categoryId${index}`] || ''}</label>
                        </div>
                      ) : (
                        ''
                      )}

                      <div
                        className='col-lg-1 d-flex justify-content-center align-items-center'
                        style={{textAlign: 'right'}}
                      >
                        <button
                          onClick={() => removeAccommodation(item.id, index)}
                          className='btn btn-danger'
                        >
                          <FontAwesomeIcon icon={faMinus} />
                        </button>
                      </div>
                    </div>
                  </>
                )
              })}

              <div className='row'>
                <div className='col-12' style={{textAlign: 'right'}}>
                  <button
                    className='btn btn-success'
                    onClick={() => {
                      addaccommodation()
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </div>
              </div>

              <div style={{display: 'flex', justifyContent: 'center', fontSize: '1.2rem'}}>
                <label className='text-danger'>{error.accommodationError || ''}</label>
              </div>

              <div className={`d-flex pt-15 justify-content-center`}>
                <button
                  type='button'
                  className={`btn btn-lg btn-light-success me-3`}
                  onClick={props.onHide}
                >
                  {t('Cancel')}
                </button>

                <button
                  type='button'
                  disabled={disable}
                  className={`btn btn-lg btn-success monthBtn me-3`}
                  onClick={() => validate()}
                >
                  {!disable && t('Save')}
                  {disable && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      {t('Please wait...')}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }

function Accommodation() {
  let t = Tr()
  const {menuId, menuIdAdd, menuIdDelete, menuIdEdit} = useMenuIdPermissions()

  const [showPopup, setShowPopup] = useState(false)
  const [accommodationList, setAccommodationList] = useState([])
  const [orgAccommodationList, setOrgAccommodationList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)

  const [passdata, setPassData] = useState<{apiName: string; data: any[]}>({
    apiName: '',
    data: [{en_name: '', ru_name: '', uz_name: '', categoryId: '', image: ''}],
  })

  

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('English Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.en_name != '' ? row.en_name : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.en_name),
      },
      {
        name: t('Russian Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.ru_name != '' ? row.ru_name : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.ru_name),
        filter: true,
      },
      {
        name: t('Uzbek Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.uz_name != '' ? row.uz_name : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.uz_name),
        filter: true,
      },

      {
        name: t('Values'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.data.map((item: any) => item.en_name).join(', ')}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => row.data.map((item: any) => item.en_name).join(', '),
        filter: true,
      },

      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {menuIdEdit ?<button
              className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
              title='Edit'
              onClick={() => {
                const trimData = (data: any[]) => {
                  return data.map((item) => ({
                    en_name: item.en_name?.trim() || '',
                    ru_name: item.ru_name?.trim() || '',
                    uz_name: item.uz_name?.trim() || '',
                    id: item.id || '',
                    categoryId: item.categoryId,
                    image: item.image,
                  }))
                }

                const trimmedData = trimData(row.data)
                setPassData({apiName: row.apiName, data: trimmedData})
                setShowPopup(true)
              }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </button> :""}
          </>
        ),
        width: '140px',
      },
    ],
    [t]
  )

  // call Accommodation list api
  const accommodationlistapicall = async () => {
    var response: any = await fetchData('admin/accommodationfilters', Object)

    if (response.status == '200') {
      setAccommodationList(response.data)
      setOrgAccommodationList(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Accommodation'
    accommodationlistapicall()
  }, [])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Accommodation')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div
          className='d-flex justify-content-end col-xl-8 '
          data-kt-user-table-toolbar='base'
        ></div>
      </div>
    )
  }

  //search function
  const accommodationSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text === '' || text == null || text === undefined) {
      setAccommodationList(orgAccommodationList)
    } else {
      const tmp: any = orgAccommodationList.filter((item: any) => {
        return (
          (item.en_name != null &&
            item.en_name !== '' &&
            item.en_name.toLowerCase() === text.toLowerCase()) ||
          (item.en_name != null &&
            item.en_name !== '' &&
            item.en_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.ru_name != null &&
            item.ru_name !== '' &&
            item.ru_name.toLowerCase() === text.toLowerCase()) ||
          (item.ru_name != null &&
            item.ru_name !== '' &&
            item.ru_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.uz_name != null &&
            item.uz_name !== '' &&
            item.uz_name.toLowerCase() === text.toLowerCase()) ||
          (item.uz_name != null &&
            item.uz_name !== '' &&
            item.uz_name.toLowerCase().includes(text.toLowerCase()))
        )
      })
      setAccommodationList(tmp)
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgAccommodationList.length > 0 ? (
              <>
                <DataTable
                  columns={column}
                  data={accommodationList}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader
                      search={searchTerm}
                      isfoc={focus}
                      customSearch={accommodationSearch}
                    />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column mt-10 pt-20 pb-2 mb-2'>
                    <h2 className='fs-2x fw-bold '>{t('Welcome To Accommodation')}</h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold'>
                    {t('There are no Accommodation')}
                  </p>
                  {menuIdAdd ? (
                    <Link
                      to='#'
                      className='btn btn-success monthBtn'
                      onClick={() => setShowPopup(true)}
                    >
                      {t('Add Accommodation')}
                    </Link>
                  ) : (
                    ''
                  )}
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {showPopup && (
          <Popup
            show={showPopup}
            passdata={passdata}
            onHide={() => {
              setShowPopup(false)

              accommodationlistapicall()
            }}
          />
        )}
      </div>
    </>
  )
}

export default Accommodation
